<template>
    <div class="appSet">
         <div class="show_container">
             <div class="staff_manage_head">
               <div class="staff_search flex align-cen">
                 <div class="search_box">
                     <el-input placeholder="关联订单ID" v-model="search" clearable> </el-input>
                </div>
                 <div class="search_box" style="margin-left:20px">
                     <el-input placeholder="绑定员工姓名" v-model="search1" clearable> </el-input>
                </div>
                <div class="search_box" style="margin-left:20px">
                     <el-input placeholder="绑定员工手机号" v-model="search2" clearable> </el-input>
                </div>
                <div class="public-btn-small flex align-cen" style="padding-left:20px">
                    <div class="public-btn-small-primary" @click="classSelect">搜索</div>
                    <div class="public-btn-small-text" @click="reset">重置筛选条件</div>
                </div>
               </div>
               <div class="staff_search flex align-cen">
                <div class="staff_search_label">关联产品：</div>
                <div class="search_box1">
                      <el-select
                        v-model="value"
                        clearable
                        placeholder="请选择"
                        @change="classSelect"
                    >
                        <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.appName"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </div>
               </div>
               <div class="staff_search flex align-cen">
                 <div class="staff_search_label">服务时间：</div>
                   <el-date-picker
                    v-model="value1"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="pickerOptions2"
                    @change="classSelect"
                    >
                    </el-date-picker>
               </div>
             </div>
               <div class="staff_manage_center">
                 <div class="businessList-container-table">
                    <el-table
                ref="multipleTable"
                :data="itemList"
                tooltip-effect="dark"
                style="width: 100%"
                id='mytable'
                :header-cell-style="{background:'#fff',color:'#90909e',paddingBottom:'20px'}"
                >
                 <el-table-column  label="关联订单ID" align="center">
                  <template slot-scope="scope">
                      <p>{{scope.row.orderId || '-'}}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="appName" label="关联产品" align="center">
                 </el-table-column>
                  <el-table-column  label="服务开始时间" align="center">
                  <template slot-scope="scope">
                      <p>{{scope.row.startTime || '-'}}</p>
                  </template>
                </el-table-column>
                <el-table-column  label="服务结束时间" align="center">
                  <template slot-scope="scope">
                      <p>{{scope.row.endTime || '-'}}</p>
                  </template>
                </el-table-column>
                 <el-table-column prop="accountNum" label="套餐账号数" align="center">
                 </el-table-column>
                  <el-table-column prop="allocateNum" label="已分配账号" align="center">
                 </el-table-column>
                  <el-table-column prop="unallocatedNum" label="剩余可分配账号" align="center">
                 </el-table-column>
                   <el-table-column
                    fixed="right"
                    label="操作"
                    align="center"
                    width="150"          
                    >
                     <template slot-scope="scope">
                      <el-button type="text" style="color:red" @click="openAssignAuth(scope.row)">分配权限</el-button> 
                     </template>
                   </el-table-column>
             </el-table>
              <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
                 </div>
               </div>
         </div>
    </div>
</template>
<script>
import { getappGl,getAppAuthList,getCurrentUser} from "@/api/enterprise/index"; // 关联产品列表、应用权限列表
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'appSet',
    components:{
      paginaTion
    },
    data() {
        return {
            search:'',
            search1:'',
            search2:'',
            value:'',
            options:[],
            value1:'',
            itemList:[],
               pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        bussID:'',
        start_time:'',
        end_time:'',
        currentPage: 1, //初始页
        PageSize: 10, //每页的数据
        totalCount:0,
        currentInfo:{},
        officialType:''
        }
    },
    created () {
     const businessInfo = this.$locaStorage.setAge().get('businessInfo')
     const currentUserInfo = this.$locaStorage.setAge().get('currentUserInfo')
     this.officialType = this.$locaStorage.setAge().get('officialType')
     this.bussID = businessInfo.id
     this.getUserInfo()
     this.getoptionList()
     this.getthisInfo()
    },
    methods: {
          // 获取当前用户信息
        getUserInfo(){
             getCurrentUser({
                id:this.bussID,
              },'enterprise')
            .then(res => {
            this.currentInfo = res.data.user_info
            })
        },
      // 打开分配权限页面
      openAssignAuth(data){
        if(this.currentInfo.isAdmin == 1 || this.currentInfo.isAdmin == 2){
          this.$router.push({
          name:'AssignAuth',
          query:{
            id:data.id,
            appName:data.appName,
          }
        })
        }else{
            this.$util.Notifi('暂无权限','error','fa-exclamation-circle') 
        }
      },
      // 重置筛选条件
      reset(){
        this.search = ""
        this.search1 = ""
        this.search2 = ""
        this.value = ""
        this.value1 = ""
        this.start_time = ""
        this.end_time = ""
        this.currentPage = 1
        this.getthisInfo()
      },
               // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getthisInfo()
      },
      classSelect(){
           if(this.value1){
             this.start_time = this.value1[0]
            this.end_time = this.value1[1]
            }
            else{
                this.start_time=""
                this.end_time = ""
            }
            this.currentPage = 1
            this.getthisInfo()
      },
      // 获取应用权限列表
      getthisInfo(){
        let params = {
          id:this.bussID,
          orderId:this.search,
          userName:this.search1,
          loginName:this.search2,
          appId:this.value,
          startTime:this.start_time,
          endTime:this.end_time,
          size:this.PageSize,
          current:this.currentPage,
          officialType:this.officialType
        }
         getAppAuthList(params,'enterprise')
          .then(res => {
            this.itemList = res.data.records
            this.totalCount = res.data.total
           
          })
          .catch(err => {

          })
      },
      // 获取关联产品列表
      getoptionList(){
        getappGl({businessId:this.bussID,officialType:this.officialType},'enterprise')
            .then(res => {
              this.options = res.data
            })
            .catch(err => {
            })
      }
    },
}
</script>
<style lang="scss" scoped>
.appSet{
    width: 100%;
    padding-top: 30px;
    .show_container{
     max-width: 1400px;
    min-width: 1145px;
    background: #fff;
    box-shadow: 0 0 7px 0 rgba(197,197,197,0.34);
    border-radius: 2px;
    margin: 0 auto;
    .staff_manage_head{
    height: 200px;
    background: rgba(246,249,255,1);
    border-radius: 2px;
    padding: 0 40px;
    .staff_search{
       padding-top: 20px;
    }
       .search_box{
        position: relative;
        width: 220px;
        height: 40px;
        line-height: 40px;
        background: rgba(255,255,255,1);
        border: 1px solid rgba(234,234,234,1);
        box-sizing: border-box;
         border-radius: 20px;
        .el-input{
            display: block;
            width: 100%;
            height: 100%;
            text-align: left;
            padding-left: 12px;
            box-sizing: border-box;
            color: #333;
        }
        .search_icon{
         position: absolute;
        right: 3px;
        top: 3px;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: url('../../../assets/images/setting_icon.png') 0 -293px no-repeat;
        cursor: pointer;
        }
    }
    }
    .staff_manage_center{
      margin-bottom: 30px;
    }
    }
}
::v-deep{
      .jiange{
      padding-bottom: 20px;
      padding-right: 20px;
    }
    .el-table{
        td{
            padding: 5px 0 !important;
        }
    }
    .search_box{
            .el-input__inner{
             outline: 0;
            background: 0;
            border: 0;
            box-shadow: none;
            appearance: none;
            }
            .el-input__suffix{
                right: 40px;
            }
    }
    .acBtn{
        .el-button--primary{
            background-color: #0157ff !important;
            border-radius: 20px;
            border: none;
            padding: 0;
            width: 89px;
            height: 28px;
            line-height: 28px;
            span{
                font-size: 12px;
            }
        }
    }
}
</style>